export default "__VITE_ASSET__CcqxS4Rg__"